"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currencies = exports.initialCurrenciesState = exports.currenciesAdapter = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxAct = require("redux-act");

var _utils = require("@alycecom/utils");

var _currencies = require("./currencies.actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var currenciesAdapter = (0, _utils.createEntityAdapter)();
exports.currenciesAdapter = currenciesAdapter;
var initialCurrenciesState = currenciesAdapter.getInitialState({
  status: _utils.StateStatus.Idle
});
exports.initialCurrenciesState = initialCurrenciesState;
var currencies = (0, _reduxAct.createReducer)({}, initialCurrenciesState).on(_currencies.loadCurrenciesRequest, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    status: _utils.StateStatus.Pending
  });
}).on(_currencies.loadCurrenciesSuccess, function (state, payload) {
  return _objectSpread(_objectSpread(_objectSpread({}, state), currenciesAdapter.setAll(payload, state)), {}, {
    status: _utils.StateStatus.Fulfilled
  });
}).on(_currencies.loadCurrenciesFail, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    status: _utils.StateStatus.Rejected
  });
});
exports.currencies = currencies;